import { Label as LabelPrimitive } from "radix-ui";
import React from "react";

const Label: React.FC<React.ComponentProps<typeof LabelPrimitive.Root>> = ({
  ...props
}) => <LabelPrimitive.Root {...props} />;

Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
